import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

const load = (k, def) => {
  try { return JSON.parse(localStorage.getItem(k)) || def; } catch { return def; }
};

export function AppProvider({ children }) {
  const [saved, setSaved] = useState(() => load("fpv_saved", []));
  const [compare, setCompare] = useState(() => load("fpv_compare", []));
  const [settings, setSettings] = useState({});

  useEffect(() => { api.get("/settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);
  useEffect(() => { localStorage.setItem("fpv_saved", JSON.stringify(saved)); }, [saved]);
  useEffect(() => { localStorage.setItem("fpv_compare", JSON.stringify(compare)); }, [compare]);

  const toggleSave = (id) => {
    setSaved((prev) => {
      if (prev.includes(id)) { toast("Removed from saved"); return prev.filter((x) => x !== id); }
      toast.success("Saved to your list ❤️");
      return [...prev, id];
    });
  };

  const toggleCompare = (id) => {
    setCompare((prev) => {
      if (prev.includes(id)) return prev.filter((x) => x !== id);
      if (prev.length >= 3) { toast.error("You can compare up to 3 properties"); return prev; }
      toast.success("Added to compare");
      return [...prev, id];
    });
  };

  const isSaved = (id) => saved.includes(id);
  const inCompare = (id) => compare.includes(id);

  return (
    <AppContext.Provider value={{ saved, compare, settings, toggleSave, toggleCompare, isSaved, inCompare, setCompare }}>
      {children}
    </AppContext.Provider>
  );
}
